import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import './Contact.css';

function Contact() {
    return (
        <>
            <Helmet>
                <title>Contact NeuAIs - Get Support & Sales Information</title>
                <meta name="description" content="Contact NeuAIs for technical support, sales inquiries, or general questions. Available 24/7 for enterprise customers. Email: support@neuais.com" />
                <meta name="keywords" content="GPU support, cloud computing help, technical support, enterprise sales, contact NeuAIs" />
                <link rel="canonical" href="https://lab.neuais.com/contact" />
            </Helmet>

            <Breadcrumbs />

            <div className="info-page">
                <div className="info-container">
                    <h1>Contact Us</h1>
                    <div className="info-content">
                        <section>
                            <h2>Get in Touch</h2>
                            <p>
                                Need help with your GPU workloads or have questions about our platform?
                                Our team is here to assist you. Choose the best way to reach us below.
                            </p>
                        </section>

                        <section className="contact-info">
                            <div className="contact-item">
                                <h3>📧 General Support</h3>
                                <p><a href="mailto:support@neuais.com">support@neuais.com</a></p>
                                <p className="contact-desc">Technical issues, account help, billing questions</p>
                            </div>

                            <div className="contact-item">
                                <h3>💼 Sales Inquiries</h3>
                                <p><a href="mailto:sales@neuais.com">sales@neuais.com</a></p>
                                <p className="contact-desc">Enterprise pricing, custom solutions, bulk GPU hours</p>
                            </div>

                            <div className="contact-item">
                                <h3>🔧 Technical Support</h3>
                                <p><a href="mailto:tech@neuais.com">tech@neuais.com</a></p>
                                <p className="contact-desc">API issues, integration help, debugging assistance</p>
                            </div>

                            <div className="contact-item">
                                <h3>⚖️ Legal & Compliance</h3>
                                <p><a href="mailto:legal@neuais.com">legal@neuais.com</a></p>
                                <p className="contact-desc">Terms, privacy, data agreements, compliance</p>
                            </div>
                        </section>

                        <section>
                            <h2>Office Hours</h2>
                            <ul>
                                <li><strong>Standard Support:</strong> Monday - Friday, 9:00 AM - 6:00 PM EST</li>
                                <li><strong>Enterprise Support:</strong> 24/7 availability via priority queue</li>
                                <li><strong>Response Time:</strong> Within 2 hours for critical issues</li>
                            </ul>
                        </section>

                        <section>
                            <h2>Frequently Asked Questions</h2>
                            <ul>
                                <li><strong>How quickly will I get a response?</strong> Most inquiries are answered within 4-8 business hours. Enterprise customers receive priority support.</li>
                                <li><strong>Can I schedule a demo?</strong> Yes! Email sales@neuais.com to book a personalized platform walkthrough.</li>
                                <li><strong>Where is your data center?</strong> We operate in US-East, US-West, and EU regions with data residency options.</li>
                                <li><strong>Do you offer educational discounts?</strong> Yes! Contact sales@neuais.com with your .edu email for special pricing.</li>
                            </ul>
                        </section>

                        <section>
                            <h2>Other Resources</h2>
                            <p>
                                <Link to="/about">Learn more about NeuAIs</Link> |
                                <Link to="/privacy"> Privacy Policy</Link> |
                                <Link to="/terms"> Terms of Service</Link>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;
